import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { DashboardPage } from './pages/admin/dashboard';
import TicketMain from './pages/admin/ticket';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import EditTicket from './pages/admin/edit';
import UserTicket from './pages/ticket';
import { LoadingScreen } from './components/Background';
import { AccountController } from './contexts/AccountContexts';
import { NotificationsPage } from './pages/admin/notifications';
import { NotificationController } from './contexts/NotificationContexts';
import { ContentController } from './contexts/ContentContext';
import { SettingsMain } from './pages/admin/settings';
import { SetupPage } from './pages/admin/setup';
import { QuickResponsesSetup } from './pages/admin/setup/quick-responses';
import { CategorySetup } from './pages/admin/setup/category-setup';
import { PrioritySetup } from './pages/admin/setup/priority-setup';
import { AnnouncementsSetup } from './pages/admin/setup/announcements-setup';
import { ProfileSettings } from './pages/admin/settings/profile-settings';
import LoginPage from './pages/login';
import { SetupPassword } from './pages/setup-password';
import { ModalController } from './contexts/ModalContexts';
import { EmployeeAnnouncementsSetup } from './pages/admin/setup/employee-announcements';
import './i18n'
import { PreferencesPage } from './pages/admin/settings/preferences-settings';
import Portal from './portal';
import { UsersPage } from './pages/admin/users';
import { LandingPage } from './pages/home';
import { PermissionController } from './contexts/PermissionContexts';
import { ExcusesSetup } from './pages/admin/setup/excuses-setup';
import { ServerSetup } from './pages/admin/setup/server-setup';
import { UserHomePage } from './pages/member/home';
import { UserCreateTicketPage } from './pages/member/create-ticket';
import { UserTicketHistoryPage } from './pages/member/ticket-history';
import { UserTicketPage } from './pages/member/ticket';
import { MemberNavigator } from './pages/member/main';
import { AdminNavigator } from './pages/admin/main';
import { MembersPage } from './pages/admin/members/main';
import { MemberProfilePage } from './pages/admin/members/member-profile';
import { SearchBannedPage } from './pages/admin/members/search-banned';
import { SearchMembersPage } from './pages/admin/members/search-members';
import { FAQSetup } from './pages/admin/setup/faq-setup';
import { UserFAQPage } from './pages/member/faq';
import { FAQPage } from './pages/faq';
import { StatisticsPage } from './pages/admin/statistics';
import { UserDetail } from './pages/admin/userDetail';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename='/' >
        <AccountController>
            <PermissionController>
                <ContentController>
                    <ModalController>
                        <NotificationController>
                            <Routes>
                                <Route path="/" element={<App />} />
                                <Route path="/portal" element={<Portal />} />
                                <Route path="/home" element={<LandingPage />} />
                                <Route path="/faq" element={<FAQPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                {/* <Route path="/create-ticket" element={<CreateTicket />} /> */}
                                <Route path="/ticket/:ticket_info" element={<UserTicket />} />
                                <Route path="/setup-password/:generated_token" element={<SetupPassword />} />
                                <Route path="/admin" element={<AdminNavigator />}>
                                    <Route path="dashboard" element={<DashboardPage />} />
                                    <Route path="ticket" element={<TicketMain />} />
                                    <Route path=":ticket_info/edit" element={<EditTicket />} />
                                    <Route path="notifications" element={<NotificationsPage />} />
                                    <Route path="users" element={<UsersPage />} />
                                    <Route path='users/:userId' element={<UserDetail />} />
                                    <Route path="members" element={<MembersPage />} >
                                        <Route path="member-profile/:member_id" element={<MemberProfilePage />} />
                                        <Route path="search-members" element={<SearchMembersPage />} />
                                        <Route path="search-banned" element={<SearchBannedPage />} />
                                        {/* <Route path="search-game-banned" element={<SearchGameBannedPage />} /> */}
                                    </Route>
                                    <Route path="statistics" element={<StatisticsPage />} />
                                    <Route path="settings" element={<SettingsMain />} >
                                        <Route path="profile-settings" element={<ProfileSettings />} />
                                        <Route path="preference-settings" element={<PreferencesPage />} />
                                    </Route>
                                    <Route path="setup" element={<SetupPage />}>
                                        <Route path="quick-replies" element={<QuickResponsesSetup />} />
                                        <Route path="category-setup" element={<CategorySetup />} />
                                        <Route path="priority-setup" element={<PrioritySetup />} />
                                        <Route path="server-setup" element={<ServerSetup />} />
                                        <Route path="announcements-setup" element={<AnnouncementsSetup />} />
                                        <Route path="faq-setup" element={<FAQSetup />} />
                                        <Route path="employee-announcements-setup" element={<EmployeeAnnouncementsSetup />} />
                                        <Route path="excuses-setup" element={<ExcusesSetup />} />
                                    </Route>
                                </Route>
                                <Route path="/member" element={<MemberNavigator />}>
                                    <Route path="home" element={<UserHomePage />} />
                                    <Route path="create-ticket" element={<UserCreateTicketPage />} />
                                    <Route path="ticket-history" element={<UserTicketHistoryPage />} />
                                    <Route path="ticket/:ticket_info" element={<UserTicketPage />} />
                                    <Route path="faq" element={<UserFAQPage />} />
                                </Route>
                                <Route path='*' element={<Navigate to="/" replace />} />
                            </Routes>
                        </NotificationController>
                    </ModalController>
                </ContentController>
            </PermissionController>
        </AccountController>
        <LoadingScreen />
    </BrowserRouter>
);

// reportWebVitals();
